@if (!editing) {
  <div class="heading-display" [class.edit-mode]="editMode">
    <h2 [id]="elementId" tabindex="-1" (click)="startEdit()" [class.clickable]="editMode">{{ documentNode.content || 'New Heading' }}</h2>
    @if (editMode) {
      <div class="heading-actions">
        <button mat-icon-button matTooltip="Edit heading" aria-label="Edit heading" (click)="startEdit()">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Delete heading" aria-label="Delete heading" (click)="removeHeading()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }
  </div>
} @else {
  <div class="heading-edit-wrapper">
    <mat-form-field appearance="outline" class="heading-edit-field">
      <mat-label>Heading</mat-label>
      <input matInput [formControl]="headingControl" (keydown)="onInputKey($event)" (blur)="onBlur()" placeholder="Enter heading" />
    </mat-form-field>
    <div class="heading-edit-actions">
      <button
        mat-icon-button
        color="primary"
        matTooltip="Save"
        aria-label="Save heading"
        (mousedown)="$event.preventDefault()"
        (click)="saveEdit()"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Cancel" aria-label="Cancel edit" (mousedown)="$event.preventDefault()" (click)="cancelEdit()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}
@if (documentNode.comments?.length > 0) {
  @for (comment of documentNode.comments; track comment) {
    <app-comment-rail [nodeId]="documentNode?.id" [reviewerMode]="false" [comment]="comment"></app-comment-rail>
  }
}
